/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Web_Scraping_Tlm_0Inputs */

const en_svc_web_scraping_tlm_0 = /** @type {(inputs: Svc_Web_Scraping_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`renderer`)
};

const ar_svc_web_scraping_tlm_0 = /** @type {(inputs: Svc_Web_Scraping_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العارض`)
};

const bn_svc_web_scraping_tlm_0 = /** @type {(inputs: Svc_Web_Scraping_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`renderer`)
};

const de_svc_web_scraping_tlm_0 = /** @type {(inputs: Svc_Web_Scraping_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-Renderer`)
};

const es_svc_web_scraping_tlm_0 = /** @type {(inputs: Svc_Web_Scraping_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`renderizador`)
};

const fr_svc_web_scraping_tlm_0 = /** @type {(inputs: Svc_Web_Scraping_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moteur de rendu`)
};

const pt_svc_web_scraping_tlm_0 = /** @type {(inputs: Svc_Web_Scraping_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`renderizador`)
};

const zh_svc_web_scraping_tlm_0 = /** @type {(inputs: Svc_Web_Scraping_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`渲染器`)
};

const tr_svc_web_scraping_tlm_0 = /** @type {(inputs: Svc_Web_Scraping_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`oluşturucu`)
};

const ru_svc_web_scraping_tlm_0 = /** @type {(inputs: Svc_Web_Scraping_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`рендерер`)
};

const pl_svc_web_scraping_tlm_0 = /** @type {(inputs: Svc_Web_Scraping_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renderer`)
};

/**
* | output |
* | --- |
* | "renderer" |
*
* @param {Svc_Web_Scraping_Tlm_0Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_web_scraping_tlm_0 = /** @type {((inputs?: Svc_Web_Scraping_Tlm_0Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Web_Scraping_Tlm_0Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_web_scraping_tlm_0(inputs)
	if (locale === "bn") return bn_svc_web_scraping_tlm_0(inputs)
	if (locale === "de") return de_svc_web_scraping_tlm_0(inputs)
	if (locale === "es") return es_svc_web_scraping_tlm_0(inputs)
	if (locale === "fr") return fr_svc_web_scraping_tlm_0(inputs)
	if (locale === "pt") return pt_svc_web_scraping_tlm_0(inputs)
	if (locale === "zh") return zh_svc_web_scraping_tlm_0(inputs)
	if (locale === "tr") return tr_svc_web_scraping_tlm_0(inputs)
	if (locale === "ru") return ru_svc_web_scraping_tlm_0(inputs)
	if (locale === "pl") return pl_svc_web_scraping_tlm_0(inputs)
	return en_svc_web_scraping_tlm_0(inputs)
});
export { svc_web_scraping_tlm_0 as "svc_web-scraping_tlm_0" }